import { TextField } from '@mui/material';
import styles from './textFieldStyles';

const CustomTextField = (props: any) => {
	const classes = styles();

	return (
		<>
			<TextField
				{...props}
				id={props?.id || 'outlined-basic'}
				variant="outlined"
				InputLabelProps={{ style: { fontSize: 14 }, shrink: props.value || '' }}
				className={`${classes.textField} ${props.className}`}
				autoComplete="off"
			/>
		</>
	);
};

export default CustomTextField;
